import React from 'react';
import axios from "axios";
// import { useState } from 'react';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import Cookies from "js-cookie";
import { v4 as uuid } from "uuid";

export default function Welcome() {

  useEffect(() => {
    document.title = "Welcome to DANCExDANCE";
  }, []);

  // Get (or create) unique ID for this patron
  const [userID2, setUserID2] = useState("initializing");
  if (userID2 == "initializing") {
    const c = Cookies.get("UserID2");
    if (c == null) {
      // generate  unique random identifier
      const unique_id = uuid();
      Cookies.set("UserID2", unique_id, { expires: 7, path: "/" });
      setUserID2(unique_id);
    } else {
      setUserID2(c);
    }
  }

  // The QR code specifies which show: T1, T2, ..., T9 (for techs) 
  // and F1, F2, F3, ... F9 for Friday performances (5:00, 5:30, 6:00, plus some extras)
  const queryParameters = new URLSearchParams(window.location.search)
  const showID = queryParameters.get("showID")

  const navigate = useNavigate();

  const grantPermission = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/grantpermission/" + userID2)
    .then((response) => {
      console.log(response.data);
    })
    .catch((ex) => {
      console.log("grantPermission(): An unexpected error has occurred");
    });     
    navigate("/preshowquestions?showID=" + showID); // redirects to next page regardless of errors
    // Might need to escape the showID
  };

  const denyPermission = () => {
    axios
    .get(process.env.REACT_APP_HOST + "/mysecretkey/denypermission/" + userID2)
    .then((response) => {
      console.log(response.data);
    })
    .catch((ex) => {
      console.log("denyPermission(): An unexpected error has occurred");
    });
    navigate("/preshowquestions?showID=" + showID); // redirects to next page regardless of errors
  }

  return (
    <>

      <h2>Welcome to the DANCExDANCE research project</h2>
      <p>This performance explores our individual and collective interactions with technology. 
        We invite you to participate through your phone.</p>
      <p>We would like your permission to use your anonymous responses as part of our analysis. 
        Please review the informed consent card you were given, and then indicate whether you accept.
        You can fully participate in the performance regardless of whether you give us permission.</p>
        <hr />
        <p>I have reviewed the informed consent card or had it read to me; 
          I am at least 18 years old; my questions have been answered to my satisfaction and I 
          voluntarily agree to participate in this research study.
        </p>
        <button className="button is-green" onClick={() => grantPermission()}>Yes, I agree</button>
      <br />
      <button className="button is-green" onClick={() => denyPermission()}>No, I do not agree</button>

    </>
  );
}

